import api from '../../store/config/api';
import { format } from '../../util/url';
import {
  TABLE_ROW as SCHEMA,
  TABLE_ROW_LIST as SCHEMA_LIST
} from '../../schemas';

export const [
  GET_TABLE_ROWS,
  GET_TABLE_ROWS_REQUEST,
  GET_TABLE_ROWS_SUCCESS,
  GET_TABLE_ROWS_FAILURE
] = api.buildTypes('GET_TABLE_ROWS');

export function getTableRows({ teamName, tableID, limit = 10, pageToken = 0 }) {
  const query = {
    limit,
    pageToken
  };
  const url = format({
    pathname: `/teams/${teamName}/tables/${tableID}/rows`,
    query
  });
  return {
    type: GET_TABLE_ROWS,
    payload: {
      url,
      schema: SCHEMA_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ADD_TABLE_ROW,
  ADD_TABLE_ROW_REQUEST,
  ADD_TABLE_ROW_SUCCESS,
  ADD_TABLE_ROW_FAILURE
] = api.buildTypes('ADD_TABLE_ROW');

export function addTableRow({ teamName, tableID, rowData }) {
  return {
    type: ADD_TABLE_ROW,
    payload: {
      url: `/teams/${teamName}/tables/${tableID}/rows`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: rowData
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/tableRows.js